export default "__VITE_ASSET__BX61_m_3__"